import React from 'react';
import { Box, Typography } from '@mui/material';

// 全屏平铺水印(昵称 · 匿名xxxx · 日期),截图可溯源,pointer-events 穿透不挡操作
export default function Watermark({ text }: { text: string }) {
  const tiles: React.ReactNode[] = [];
  const tileW = 340;
  const tileH = 180;
  for (let i = 0; i < 32; i++) {
    tiles.push(
      <Box
        key={i}
        sx={{
          width: tileW,
          height: tileH,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Typography
          sx={{
            color: 'rgba(0,0,0,0.055)',
            fontSize: 13,
            transform: 'rotate(-28deg)',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            pointerEvents: 'none',
          }}
        >
          {text}
        </Typography>
      </Box>,
    );
  }
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexWrap: 'wrap',
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 1400,
      }}
    >
      {tiles}
    </Box>
  );
}
